<template>
  <div class="position-relative w-100">
    <b-form-input
      ref="input_ref"
      :disabled="isDisabled"
      :state="state"
      v-model="query"
      placeholder="Выберите объект"
      autocomplete="off"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @click="isFocus = true"
    />

    <b-input-group-append>
      <slot name="append-btn" :on-clear="onClear" :query="query" :disabled="isDisabled">
        <button type="button" class="custom-btn-select" :disabled="isDisabled" @mousedown.prevent="onClick">
          <v-icon v-if="query" name="buttons/cross" :size="11"/>
          <v-icon v-else-if="isFocus" name="buttons/collapse_chevrons_down" :size="10"/>
          <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
        </button>
      </slot>
    </b-input-group-append>

    <div v-if="isFocus" class="custom-dropdown-select" :class="{ 'drop-up': dropUp }">
      <div class="custom-dropdown-list-scroll">
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="custom-dropdown-select-item"
          @mousedown.prevent="onSelect(item)"
        >
          <div class="text-small">{{ item.name }}</div>
          <div class="text-secondary text-small">Заказчик: {{item.customer_name}} | Город: {{item.town_name}}</div>
          <div v-if="item.address" class="text-secondary text-small">Адрес: {{item.address}}</div>
        </div>
      </div>

      <div v-if="filteredItems.length === 0 && query" class="empty-state-container p-2">
        <v-icon name="navbar/empty_table" :size="45"/>
        <small class="text-muted">Ничего не найдено</small>
      </div>
    </div>
  </div>
</template>

<script>
import locations from "../../network/locations";

export default {
  name: "LocationSelect",
  mixins: [ locations ],
  props: {
    isDisabled: { type: Boolean, default: false },
    value: { type: Number, default: null },
    state: { type: Boolean, default: null },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isFocus: false,
      query: '',
      items: [],
      selectedItem: null,
    }
  },
  mounted() {
    this.getItems();
  },
  computed: {
    filteredItems() {
      const query = this.query ? this.query.trim().toLowerCase() : '';

      if (!query) return this.items;

      if (this.selectedItem && this.selectedItem.name.toLowerCase() === query) return this.items;

      return this.items.filter(item => item.name.toLowerCase().includes(query));
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.configure(newValue);
      }, immediate: true
    },
  },
  methods: {
    async configure(id) {
      if (id && id > 0) {
        const result = await this.getLocationById(id);

        if (result && result.data) {
          this.query = result.data.name;
          this.selectedItem = result.data;
          return;
        }
      }

      this.query = '';
      this.selectedItem = null;
    },
    async getItems(query) {
      const data = {
        query: query,
        payment_type_int: -1,
        currentPage: 1,
        perPage: 400
      }
      const result = await this.getLocationsSearch(data);

      this.items = (result && result.data) ? result.data.items : [];
    },
    onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;

      if (this.selectedItem) {
        if (this.query !== this.selectedItem.name) {
          this.query = this.selectedItem.name;
        }
      } else {
        this.query = '';
      }
    },
    onClick() {
      if (this.query) {
        this.onClear();
        this.$refs.input_ref.$el.focus();
      } else {
        this.onFocusIn();
        this.$refs.input_ref.$el.focus();
      }
    },
    onSelect(item) {
      this.query = item.name;
      this.selectedItem = item;
      this.$emit('onSelect', item.id, item);
      this.onFocusOut();
    },
    onClear() {
      this.query = '';
      this.selectedItem = null;
      this.$emit('onSelect', 0, null);
    },
  },
}
</script>

<style>
.custom-dropdown-select.drop-up {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationSelect.vue